module.exports = __webpack_public_path__ + "img/planning.a2239213.jpg";